import React from 'react'
import { Link } from 'gatsby'
import {
  FaLinkedin,
  FaGithubSquare,
  FaSkype,
  FaInstagram,
  FaDribbbleSquare,
} from 'react-icons/fa'
import ResumeItem from '../components/resume'
import ResumeItem2 from '../components/resume2'
import ResumeItem3 from '../components/resume3'
import '../components/resume.css'
import '../components/project.css'
import HText1 from '../components/text1'
import Text2 from '../components/text2'
import Header2 from '../components/header2'

import Scroller from '../components/scrollP'

const AboutPage = () => (
  <div id="rect">
    <Scroller />
    <div className="HeroAbout">
      <div className="AboutW">
        <div className="About">
          <div id="AnimateImage" />
          <h4>
            Hi, This is Doruk,
            <br />
            a curious digital product designer based in Sydney{' '}
            <span role="img" aria-label="koala">
              🐨
            </span>
            <br />
            focused on building inclusive &amp; accessible products.<br />
            <br />I am interested in solving problems through systems thinking, mixed methods, co-design, sustainability to co-build scalable solutions. <br /><br />I love funk, jazz, soul, my{' '}
            <span role="img" aria-label="cat">
              🐈
            </span>
            , documentary photography, <br />
            art-house, crafty food &amp; 90's{' '}
            <span role="img" aria-label="basketball">
              🏀
            </span>
            .
          </h4>
          <br />
          <h4>
            You can view and download my <a href="/Resume_DD.pdf"> Resume</a>
            <br />
            <br />
            Get in touch with me at
            <br />
            <a href="mailto:hello@dorukdemircioglu.com">
              hello@dorukdemircioglu.com
            </a>
            <br />
          </h4>
          <h2>
            <a
              href="https://linkedin.com/in/dorukdemircioglu"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </a>{' '}
            &nbsp;{' '}
            <a
              href="https://instagram.com/dorukde/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
          </h2>
        </div>
      </div>
      <div className="ContentW">
        <div className="Content">
          <div className="SectionTitle">Experience</div>
          <ResumeItem
            MyRole="Principal Product Designer"
            Workplace="SEEK"
            Duration="2026/01 &#x2013; Current"
            City="Sydney, Australia"
            Item1="Designing agentic hiring experiences &#x2014; a strategy agent that orchestrates specialised task agents across briefing, sourcing, outreach, evaluation and selection, over a shared hiring context and memory layer"
            Item2="Adaptive interfaces under a trust-based autonomy model of five tiers, from Observer to Commander, with a trust measurement framework scoring every feature against its trust criteria before it reaches a user"
            Item3="Designed and ran a twelve-week AI learning &amp; development programme for 25+ designers across 3 squads &#x2014; prototyping, RAG and knowledge graphs, evals and observability, orchestration and multi-agentic systems"
          />
          <ResumeItem
            MyRole="Senior Product Designer"
            Workplace="Domain"
            Duration="2021/08 &#x2013; 2026/01"
            City="Sydney, Australia"
            Item1="Transformed a key property data platform for real estate professionals and institutions &#x2014; optimising agent workflows and advancing design practices (12k appraisal reports monthly)"
            Item2="Product experimentation and scalable frameworks for customer satisfaction measurement and prioritisation, improving accessibility and refining research methodologies"
            Item3="Design system team member, leading accessibility &amp; data visualisation initiatives. IxDA Sydney &amp; Domain mentorship program (2022&#x2013;2024)"
          />
          <ResumeItem
            MyRole="Senior Product Designer"
            Workplace="Antler"
            Duration="2019/12 &#x2013; 2021/08"
            City="Sydney, Australia"
            Item1="Digitally transformed a global VC&#x2019;s internal operations &amp; live event platform for investors, scaled from 10 to 26 cities"
            Item2="Designed a popular open-source SaaS for DataOps (Firetable, now Rowy.io)"
            Item3="Launched a live demo day platform utilised by 20+ global locations. Coached &amp; mentored startup founders about product &amp; design"
          />
          <ResumeItem
            MyRole="Product Designer"
            Workplace="2hats"
            Duration="2019/5 &#x2013; 2019/12"
            City="Sydney, Australia"
            Item1="SaaS platform for student and graduate careers"
            Item2="Increased completion rate of courses, onboarding &amp; registration"
            Item3="Research (interviews, practice-based), journey and stakeholder mapping, usability testing studies"
          />
          <ResumeItem
            MyRole="Product Designer"
            Workplace="Strafe"
            Duration="2018/5 &#x2013; 2018/7"
            City="Stockholm, Sweden (Remote)"
            Item1="Gamified a global eSports tracking &amp; competition App"
            Item2="Improved league structure and dynamics based on conducted research activities"
            Item3="Designing &amp; conducting user research, usability studies. Launched friends functionality, gamified leaderboard and a new voting module"
          />
          <ResumeItem
            MyRole="Product Designer"
            Workplace="Keyflow"
            Duration="2015/5 &#x2013; 2018/5"
            City="Stockholm, Sweden"
            Item1="Scandinavia&#x2019;s most innovative event management platform and consumer experience for skipping queues at nightclubs and events (150,000+ downloads, scaled to multiple cities)"
            Item2="UX and digital product across Keyflow &amp; Keyflow Business App and web platforms, usability testing, prototyping"
            Item3="Digital marketing visuals, prints, e-mail templates and visual design of business presentations"
          />
          <ResumeItem
            MyRole="Co Founder, Product Designer"
            Workplace="Streetkäk"
            Duration="2014/2 &#x2013; 2018/5"
            City="Stockholm, Sweden"
            Item1="Launched the first realtime food-truck analytics &amp; ordering App and street food marketplace in Scandinavia (100,000+ users, scaled to multiple countries)"
            Item2="User research, prototyping and usability studies, UX &amp; UI design of the iOS &amp; Android Apps"
            Item3="Brand, digital and physical marketing and communication collaterals"
          />
          <div className="SectionTitle">Education</div>
          <ResumeItem2
            MyRole="M.Des Art &amp; Design (with Excellence)"
            Workplace="UNSW (University of New South Wales)"
            Duration="2018 &#x2013; 2020"
            City="Sydney, Australia"
          />
          <ResumeItem2
            MyRole="M.Sc Materials &amp; Nanotechnology"
            Workplace="Chalmers University of Technology"
            Duration="2009 &#x2013; 2011"
            City="Gothenburg, Sweden"
          />
          <ResumeItem2
            MyRole="B.Eng Chemical Engineering"
            Workplace="Ege University"
            Duration="2003 &#x2013; 2009"
            City="Izmir, Turkey"
          />
          <ResumeItem3
            MyRole="B.Eng Chemical Engineering (Exchange)"
            Workplace="Sapienza, University of Rome, Italy"
          />
          <div className="SectionTitle">Tools &amp; Frameworks</div>
          <ResumeItem3
            MyRole="Visual Design"
            Workplace="Sketch, Figma, Adobe CC (XD, Ps, Ai, Pr, Lr, Id), C4D, Maya, Pencil(s) &amp; Sketchbook"
          />
          <ResumeItem3
            MyRole="Prototyping &amp; Testing"
            Workplace="ProtoPie, Principle, Framer, Max/MSP, Unity, Maze, Smartlook"
          />
          <ResumeItem3
            MyRole="Design System &amp; Documentation"
            Workplace="Zeplin, zeroheight, DSM, Confluence"
          />
          <ResumeItem3
            MyRole="3D Modelling"
            Workplace="Autodesk Maya, Fusion 360, Cinema 4D"
          />
          <ResumeItem3
            MyRole="Software Development"
            Workplace="Arduino programming, HTML, CSS, JS, React, p5.js"
          />
        </div>
      </div>
    </div>
  </div>
)

export default AboutPage
